var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56254 0.0487079C8.60104 0.0791941 8.72704 0.170184 8.84261 0.250886C9.95845 1.03015 10.902 2.27145 11.3572 3.55926C11.6047 4.25909 11.7018 4.79134 11.7266 5.58179C11.7555 6.50476 11.6544 7.18152 11.3619 8.0236C10.5845 10.2617 8.59925 11.9991 6.19422 12.5463C5.12181 12.7902 3.91286 12.791 2.8526 12.5482C1.91229 12.3329 0.96268 11.9121 0.236359 11.3887C0.106345 11.295 0 11.2238 0 11.2304C0 11.268 0.249725 11.751 0.387204 11.9793C0.736396 12.5592 1.10264 13.0222 1.61376 13.5298C2.35899 14.27 3.09398 14.7822 4.01725 15.2049C6.19739 16.203 8.65131 16.2636 10.8792 15.3743C11.8686 14.9794 12.752 14.4066 13.5473 13.6443C15.5044 11.7685 16.3609 9.12726 15.8595 6.51408C15.6595 5.47176 15.226 4.44564 14.611 3.55847C14.2441 3.02917 13.9043 2.63957 13.4199 2.193C12.748 1.57349 12.0928 1.13877 11.2396 0.746484C10.3937 0.35751 9.64389 0.147358 8.60671 0.0085598C8.49349 -0.00660516 8.49316 -0.00629247 8.56254 0.0487079Z",
    fill: "#2E2E34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.f835c54ed7dc67331931b30848bb157a.svg";
export { ForwardRef as ReactComponent };